import { State } from './index';

export const getUpdateFlags = (state: State, oldState: State) => {
    const { gigakombi, activeProviderType, tariffs, ff, selected, avcResult } = state;
    const gigakombiChanged = gigakombi !== oldState.gigakombi;
    const ffChanged = ff !== oldState.ff;
    const selectedChanged = selected.tariffId !== oldState.selected.tariffId;
    const avcChanged = avcResult !== oldState.avcResult;
    const tariffsChanged = tariffs && tariffs !== oldState.tariffs;
    const providerChanged = activeProviderType !== oldState.activeProviderType;

    return {
        tariffsChanged,
        gigakombiChanged,
        avcChanged,
        gigakombiChosen: selected.tariff && gigakombi && gigakombiChanged,
        providerChanged: activeProviderType !== oldState.activeProviderType,
        ff: ffChanged,
        discount: gigakombiChanged || ffChanged || selectedChanged || avcChanged || tariffsChanged,
        gigakombiPicker: gigakombiChanged || providerChanged || tariffsChanged || avcChanged,
    };
};
